import { getDateInFormatLocale } from '@utils/dateUtils';

interface PaymentCycle {
  startDate?: string;
  endDate?: string;
  [key: string]: any;
}

export function getPaymentCycleDate(selectedIdx: number, paymentCycles: PaymentCycle[]): string {
  if (paymentCycles.length > 0 && selectedIdx >= 0 && selectedIdx < paymentCycles.length) {
    const { startDate = '', endDate = '' } = paymentCycles[selectedIdx];
    return ` ${getDateInFormatLocale(startDate, 'DD MMM')} - ${getDateInFormatLocale(endDate, 'DD MMM YYYY')}`;
  }
  return '';
}

export function getBoundary(selectedIdx: number, paymentCycles: PaymentCycle[]): boolean {
  return !(selectedIdx >= 0 && selectedIdx < paymentCycles.length);
}
